import script from "./statusBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./statusBar.vue?vue&type=script&setup=true&lang=ts"

import "./statusBar.vue?vue&type=style&index=0&id=bd042410&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd042410"]])

export default __exports__